import { Model, go } from 'oderon-vue'

export const Vehicle = new Model('/vehicles')

Vehicle.getConfigs = (id) => go.get(`/vehicles/${id}/configs`)
Vehicle.patch = (id, body) => go.patch(`/vehicles/${id}`, body)
Vehicle.patchConfigs = (id, body) => go.patch(`/vehicles/${id}/configs`, body)
Vehicle.getConfigsHex = (id) => go.get(`/vehicles/${id}/configs/hex`)
Vehicle.findMini = (ps) => go.get(`/vehicles/mini`, ps)

Vehicle.findByOrgAndId = (orgId, idInOrg) =>
  go.get(`/vehicles/${orgId}/${idInOrg}`)

Vehicle.findGroups = (orgId) => go.get(`/vehicle-groups/${orgId}`)
Vehicle.findTagCloud = (orgId) => go.get(`/vehicles/tag-cloud`, { orgId })

Vehicle.findByConfig = (where) => go.get(`/vehicles/by-config`, where)
